import React from 'react';
export const HeaderContext = /*#__PURE__*/React.createContext(null);
export const HeaderContextProvider = ({
  children,
  ...context
}) => {
  return /*#__PURE__*/React.createElement(HeaderContext.Provider, {
    value: context
  }, children);
};
//# sourceMappingURL=header-context.js.map